import {connect} from 'react-redux';
import UI from './ContentUI';

const mapStateToProps = (state, ownProps) => {
    return {
        section: state.app.section.preset,
        theme: state.app.theme.js
    };
};

export default connect(mapStateToProps)(UI);
